import { BaseSyntheticEvent, useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import * as Yup from "yup";
import queryString from 'query-string';
import { yupResolver } from '@hookform/resolvers/yup';
import { passwordValidateion } from "../../../common/Valitation";
import { OnsiteTextField } from "../../../customelements/CustomInput";
import { HttpPostData, JumpPage } from "../../../common/Util";
import { ResponseParamBase } from "../../../common/Types";
import { MessageParam } from "../../Message";
import { LoginStateConext } from "../../../context/AuthContext";
import { TitleParamContext } from "../../../context/TitleContext";
import market from "../../../css/market.module.scss";
import base from "../../../css/base.module.css";

//パスワード変更画面

export interface IFormInputs {
    password: string,
    confirmPassword: string,
}

export type PageParam = {
    mailToken: string,
}

export type ResponseParam = ResponseParamBase & {

}

const schema = Yup.object({
    password: passwordValidateion,
    confirmPassword: passwordValidateion,
}).required();

export const ForgetPasswordChange = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const pageParam = queryString.parse(location.search) as PageParam;
    const ctx = useContext(LoginStateConext);
    const titleContext = useContext(TitleParamContext);
    const [checkResult, setCheckResult] = useState<ResponseParam>({ resultFlg: false, message: "" });
    const [changeResult, setChangeResult] = useState<ResponseParam>({ resultFlg: false, message: "" });


    const { register, handleSubmit, control, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            password: "",
            confirmPassword: ""
        },
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        await HttpPostData<ResponseParam>("/UserManager/ForgetPasswordChange", { password: data.password, confirmPassword: data.confirmPassword, emailToken: pageParam.mailToken }, null)
            .then(response => {
                if (response.status === 200 && response.data.resultFlg) {
                    JumpPage<MessageParam>("Message", { message: response.data.message, displayButton: false }, "", navigate);
                } else {
                    setChangeResult(response.data);
                }
            })
            .catch(e => {
                setChangeResult({ resultFlg: false, message: "情報が取得できませんでした。" });
            })
    }

    useEffect(() => {
        (async () => {
            titleContext.setParamData({ mainTitle: "サポート・製品購入", firstSubTitle: "パスワード変更", secondSubTitle: "" });
            await HttpPostData<ResponseParam>("/UserManager/ForgetPasswordCheck", { emailToken: pageParam.mailToken }, null)
                .then(response => {
                    if (response.data.resultFlg) {
                        setCheckResult(response.data);
                    } else {
                        setCheckResult(response.data);
                    }
                })
                .catch(e => {
                    setCheckResult({ resultFlg: false, message: "エラーが発生しました" });
                });
        })()
    }, [])

    return (
        <>
            <section className={market.marketArea}>
                <div className={market.marketAreaInner}>
                    {checkResult.resultFlg ?
                        <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                            <div className={market["layoutBox-l"]}>
                                <div className={market.marketInputLongTitle}>
                                    <h3>新規パスワード</h3>
                                </div>
                                <div className={market.marketInputTitleContents}>
                                    <Controller
                                        name="password"
                                        control={control}
                                        render={({ field }) => (
                                            <OnsiteTextField
                                                sx={{ textAlign: "center" }}
                                                {...field}
                                                {...register("password")}
                                                error={errors.password ? true : false}
                                                helperText={errors.password?.message}
                                                margin="normal"
                                                type="password"
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className={market["layoutBox-l"]}>
                                <div className={market.marketInputLongTitle}>
                                    <h3>新規パスワード(確認用)</h3>
                                </div>
                                <div className={market.marketInputTitleContents}>
                                    <Controller
                                        name="confirmPassword"
                                        control={control}
                                        render={({ field }) => (
                                            <OnsiteTextField
                                                sx={{ textAlign: "center" }}
                                                {...field}
                                                {...register("confirmPassword")}
                                                error={errors.confirmPassword ? true : false}
                                                helperText={errors.confirmPassword?.message}
                                                margin="normal"
                                                type="password"
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className={base.errorMessage}>{changeResult.message}</div>

                            <div className={market.marketFooterArea}>
                                <button style={{ visibility: "hidden" }} className={market.marketBackButton} type="button">戻る</button>
                                <button className={market.marketButton} type="submit" disabled={!isValid}>送信</button>
                                <button style={{ visibility: "hidden" }} className={market.marketBackButton}>＜　進む</button>
                            </div>
                        </form>
                        :
                        <div className={base.errorMessage}>{checkResult.message}</div>
                    }
                </div>
            </section>
        </>
    );
}